var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7188 4.9375L10.2188 0.1875C9.75 -0.21875 9 0.125 9 0.78125V3.28125C3.96875 3.3125 0 4.34375 0 9.09375C0 11 1.21875 12.9062 2.59375 13.9062C3 14.2188 3.625 13.8125 3.46875 13.3125C2.0625 8.78125 4.125 7.59375 9 7.53125V10.25C9 10.9062 9.75 11.25 10.2188 10.8438L15.7188 6.09375C16.0625 5.78125 16.0625 5.25 15.7188 4.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLight);
export default __webpack_public_path__ + "static/media/share-light.e715b3d62805f819d0771575831ffbbf.svg";
export { ForwardRef as ReactComponent };